import request from '@/utils/request'
import URL from './urlTranslator'

// 企业接口配置查询
export function getEnterpriseInterfaceConfigList(params) {
  return request({
    url: URL.sys.getEnterpriseInterfaceConfigList,
    method: 'get',
    params
  })
}

// 企业接口配置保存
export function saveEnterpriseInterfaceConfig(data) {
  return request({
    url: URL.sys.saveEnterpriseInterfaceConfig,
    method: 'post',
    data
  })
}

// 企业接口配置删除
export function deleteEnterpriseInterfaceConfig(data) {
  return request({
    url: URL.sys.deleteEnterpriseInterfaceConfig,
    method: 'post',
    data
  })
}

// 企业接口配置禁用启用
export function activeEnterpriseInterfaceConfig(data) {
  return request({
    url: URL.sys.activeEnterpriseInterfaceConfig,
    method: 'post',
    data
  })
}

// 企业接口配置 获取accessKey
export function getEnterpriseInterfaceConfigAccessKey() {
  return request({
    url: URL.sys.getEnterpriseInterfaceConfigAccessKey,
    method: 'get'
  })
}

// 企业接口配置 获取secretKey
export function getEnterpriseInterfaceConfigSecretKey() {
  return request({
    url: URL.sys.getEnterpriseInterfaceConfigSecretKey,
    method: 'get'
  })
}
